module.exports = __webpack_public_path__ + "static/media/rounded.d396964f.svg";